import { createErrorReportingAsyncThunk } from "../../helpers";
import { createSlice } from "@reduxjs/toolkit";
import { apiFetch } from "../../../helpers/api-fetch";

const prefix = "app/web-booking-api-access";

type State = {
  hasKey: boolean;
  keyValue: string | null; // only temporarily shown when created
  generateRequestInProgress: boolean;
};

const initialState: State = {
  hasKey: false,
  keyValue: null,
  generateRequestInProgress: false,
};

export const loadHasKey = createErrorReportingAsyncThunk(
  `${prefix}/load-has-key`,
  async () => {
    const result = await apiFetch(
      "/web-booking-api/api-integration/api-key-present"
    );
    if (!result.ok) {
      throw new Error("Error loading data");
    }
    return result.json();
  }
);

export const generateKey = createErrorReportingAsyncThunk(
  `${prefix}/generate-key`,
  async () => {
    const result = await apiFetch("/web-booking-api/api-integration/api-key", {
      method: "POST",
    });
    if (!result.ok) {
      throw new Error("Error generating key");
    }
    const res = await result.json();
    return res.key as string;
  }
);

const slice = createSlice({
  initialState,
  name: prefix,
  reducers: {
    hideKey: (state) => {
      state.keyValue = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loadHasKey.pending, (state, action) => {
        state.generateRequestInProgress = true;
      })
      .addCase(loadHasKey.fulfilled, (state, action) => {
        state.hasKey = action.payload;
        state.generateRequestInProgress = false;
      })
      .addCase(loadHasKey.rejected, (state, action) => {
        state.generateRequestInProgress = false;
      })
      .addCase(generateKey.fulfilled, (state, action) => {
        state.keyValue = action.payload;
      });
  },
});

export default slice.reducer;

export const { hideKey } = slice.actions;
